import { redirectTo } from './redirect-to';
import { environment } from 'utils/environment.utils';

export const checkExperience = () => {
    if (environment.IS_MOBILE) {
        redirectTo(environment.URLS.SITE_MOBILE_DISCLAIMER);
    }
};
